import React, { useCallback, useEffect, useRef } from 'react';
import "../../assets/styles/Profile.css";
import { useState } from "react";
import Popup from "reactjs-popup";
import { motion } from "framer-motion";
import Header from "../../components/Header.js";
import InfoUser from "../../components/Profile/InfoUser.js";
import HtmlNote from "../../components/Profile/HtmlNote.js";
import DataConfirm from "../../components/Profile/DataConfirm.js";
import iconUser from "../../icons/icon-user.png";
import iconPhone from "../../icons/icon-phone.png";
import iconMail from "../../icons/icon-mail.png";
import iconBank from "../../icons/icon-bank.png";
import iconBirthday from "../../icons/icon-birthday.png";
import Collapsible from "react-collapsible";
import iconClose from "../../icons/icon-close.png";
import iconSendMail from "../../icons/icon-send-mail.png";
import iconSendPhone from "../../icons/icon-send-phone.png";
import iconWarning from "../../icons/icon-warning.png";
import iconSuccess from "../../icons/icon-success.png";
import iconArrow from "../../icons/icon-arrow.png";
import iconPassWithdraw from "../../icons/icon-pass-withdraw.png";
import iconPassLogin from "../../icons/icon-pass-login.png";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { config } from "../../config.js";
import { apiGetRequestHistory, apiConfirmUpdate, apiUpdateAccount, apiCheckDataAccount } from "../../services/api.service.js";

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


const maskRequestCode = (code = "") => `Mã yêu cầu xxxxxx${String(code).slice(-2)}`;

function Profile() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [checkConfirm, setCheckConfirm] = useState(false);
  const [typeModal, setTypeModal] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openResult, setOpenResult] = useState(false);
  const [isSendMail, setIsSendMail] = useState(true);
  const { userName, data, webSetting } = location.state || {};
  const [linkCSKH, setlinkCSKH] = useState("");
  const [requestCode, setRequestCode] = useState("");
  const [requestHistory, setRequestHistory] = useState(null);
  const [requestHistoryError, setRequestHistoryError] = useState("");
  const [openRequestHistoryResult, setOpenRequestHistoryResult] = useState(false);
  const [showRequestHistoryHelp, setShowRequestHistoryHelp] = useState(false);
  const [isRequestHistoryCollapsed, setIsRequestHistoryCollapsed] = useState(false);
  const [recentRequests, setRecentRequests] = useState((data?.recent_requests || []).slice(0, 2));
  const [submittedRequest, setSubmittedRequest] = useState(null);
  const [pollingChecks, setPollingChecks] = useState(0);
  const [isRefreshingRequest, setIsRefreshingRequest] = useState(false);
  const [requestRefreshMessage, setRequestRefreshMessage] = useState("");
  const [isCheckingHistory, setIsCheckingHistory] = useState(false);
  const historyBusy = useRef(false);
  const refreshBusy = useRef(false);
  const requestSession = useRef(0);
  const [timesCheckData, setTimesCheckData] = useState(0);
  const [dataCheck, setDataCheck] = useState({
    name: "",
    province: "",
    bank_name: "",
    bank_number: "",
    email: "",
    phone_number: "",
  });
  const originalDataUpdate = {
    name: "",
    province: "",
    bank_name: "",
    bank_number: "",
    province: "",
    email: "",
    phone_number: "",
  };
  const [dataUpdate, setDataUpdate] = useState(originalDataUpdate);
  const [user, setUser] = useState({
    account: userName,
    update_type: "",
    status: "",
    auto_check: "",
    send_type: "",
  });
  const [errors, setErrors] = useState({});
  let contentUpdate;
  const navigate = useNavigate();

  const requestStatusText = {
    no_process: "Đang chờ xử lý",
    approved: "Đã xử lý thành công",
    removed: "Đã từ chối",
  };
  const requestTypeText = {
    full_name: "Thay đổi họ và tên",
    phone_number: "Thay đổi số điện thoại",
    email: "Thay đổi email",
    bank: "Thay đổi tài khoản ngân hàng",
    birthday: "Thay đổi ngày sinh",
    forget_password: "Cấp lại mật khẩu đăng nhập",
    forget_password_withdraw: "Cấp lại mật khẩu rút tiền",
  };
  const getVerificationStatusText = (status, sendType) => {
    if (status === "success") return "Đã nhận xác thực hợp lệ";
    if (status === "invalid") return sendType === "email"
      ? "Đã nhận xác thực nhưng sai địa chỉ email"
      : "Đã nhận xác thực nhưng sai số điện thoại";
    return sendType === "email" ? "Chưa nhận được email xác thực" : "Chưa nhận được SMS xác thực";
  };
  const updateTrackedRequest = useCallback((request) => {
    setSubmittedRequest(request);
    setRecentRequests((items) => items.map((item) =>
      (item._request_code || item.request_code) === request.request_code
        ? { ...item, ...request, _request_code: request.request_code, request_code: maskRequestCode(request.request_code) }
        : item
    ).slice(0, 2));
  }, []);

  useEffect(() => {
    if (!openConfirm || !submittedRequest?.request_code || submittedRequest.status !== "no_process" || pollingChecks >= 15) return undefined;
    let active = true;
    let busy = false;
    const intervalId = setInterval(async () => {
      if (busy) return;
      busy = true;
      const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
      if (!active) return;
      setPollingChecks((count) => count + 1);
      if (result?.code === 200 && result?.data?.request) updateTrackedRequest(result.data.request);
      busy = false;
    }, 30 * 1000);
    return () => { active = false; clearInterval(intervalId); };
  }, [openConfirm, submittedRequest?.request_code, submittedRequest?.status, pollingChecks, userName, updateTrackedRequest]);

  const schema = yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Email is invalid').required('Email is required'),
    phoneNumber: yup.string().matches(/^[0-9]+$/, 'Phone number must be digits').required('Phone number is required'),
  });

  const shouldNavigate =(!userName || userName === "undefined");
  useEffect(() => {
    if (shouldNavigate) {
      navigate('/');
    }
  }, [navigate, shouldNavigate]);

  if (!shouldNavigate) {
    const checkRequestHistory = async () => {
      if (historyBusy.current) return;
      const code = requestCode.trim();
      setRequestHistoryError("");
      if (!/^\d{8}$/.test(code)) {
        setRequestHistoryError("Vui lòng nhập đúng mã yêu cầu gồm 8 số.");
        return;
      }
      historyBusy.current = true;
      setIsCheckingHistory(true);
      const result = await apiGetRequestHistory(userName, code);
      historyBusy.current = false;
      setIsCheckingHistory(false);
      if (result?.code === 200 && result?.data?.request) {
        setRequestHistory(result.data.request);
        setOpenRequestHistoryResult(true);
      } else {
        setRequestHistoryError(result?.message || "Không tìm thấy yêu cầu.");
      }
    };

    const refreshSubmittedRequest = async () => {
      if (refreshBusy.current || !submittedRequest?.request_code) return;
      refreshBusy.current = true;
      const session = requestSession.current;
      setIsRefreshingRequest(true);
      setRequestRefreshMessage("");
      const result = await apiGetRequestHistory(userName, submittedRequest.request_code);
      refreshBusy.current = false;
      setIsRefreshingRequest(false);
      if (session !== requestSession.current) return;
      if (result?.code === 200 && result?.data?.request) {
        updateTrackedRequest(result.data.request);
        setRequestRefreshMessage(`Đã cập nhật trạng thái mới nhất lúc ${new Date().toLocaleTimeString("vi-VN")}`);
      } else {
        setRequestRefreshMessage("Không thể cập nhật trạng thái. Vui lòng thử lại.");
      }
      setIsRefreshingRequest(false);
    };

    const copySubmittedRequestCode = async () => {
      try {
        await navigator.clipboard.writeText(submittedRequest?.request_code || "");
        setRequestRefreshMessage(`Đã sao chép: ${submittedRequest?.request_code}`);
      } catch (error) {
        setRequestRefreshMessage("Không thể sao chép mã yêu cầu.");
      }
    };

    const updateUserField = (field, value) => {
      setUser((prevUser) => ({
        ...prevUser,
        [field]: value,
      }));
    };

    const inputDataCheck = (event) => {
      const { name, value } = event.target;
      setDataCheck({
        ...dataCheck,
        [name]: value,
      });
    };

    const inputDataUpdate = (event) => {
      let { name, value } = event.target;
      if (name === "birth_day") {
        value = event.target.value.replace(/-/g, "/");
      }
      setDataUpdate({
        ...dataUpdate,
        [name]: value,
      });
    };

    const openModal = (type) => {
      if (type === "FULL_NAME") {
        updateUserField("update_type", "full_name")
        setTypeModal("FULL_NAME");
      } else if (type === "PHONE_NUMBER") {
        updateUserField("update_type", "phone_number")
        setTypeModal("PHONE_NUMBER");
      } else if (type === "MAIL") {
        updateUserField("update_type", "email")
        setTypeModal("MAIL");
      } else if (type === "BANK") {
        updateUserField("update_type", "bank")
        setTypeModal("BANK");
      } else if (type === "BIRTHDAY") {
        updateUserField("update_type", "birthday")
        setTypeModal("BIRTHDAY");
      } else if (type === "PASS_LOGIN") {
        updateUserField("update_type", "forget_password");
        setTypeModal("PASS_LOGIN");
      } else if (type === "PASS_WITHDRAW") {
        updateUserField("update_type", "forget_password_withdraw");
        setTypeModal("PASS_WITHDRAW");
      }
      setErrors({});
      document.body.style.overflow = 'hidden';
      setOpen(true);
    };

    const openModalConfirm = (type) => {
      setOpenConfirm(true);
      const overlay = document.getElementsByClassName("popup-overlay")[0];
      if (overlay) overlay.style.visibility = "hidden";
    };

    const validateForm = () => {
      let errors = {};
      let formIsValid = true;
  
      if (typeModal != "BIRTHDAY") {
        // Kiểm tra trường Name
        if (!dataCheck.name) {
          formIsValid = false;
          errors.name = 'Vui lòng nhập Họ và Tên';
        }

        // Kiểm tra trường phone_number
        if (data.phone_number) {
          if (!dataCheck.phone_number) {
            formIsValid = false;
            errors.phone_number = 'Vui lòng nhập Số Điện Thoại';
          } else if (!/^\d{10}$/.test(dataCheck.phone_number)) {
            formIsValid = false;
            errors.phone_number = 'Số Điện Thoại không hợp lệ';
          }
        }

        // Kiểm tra trường email
        if (data.email) {
          if (!dataCheck.email) {
            formIsValid = false;
            errors.email = 'Vui lòng nhập Email';
          } else if (!/\S+@\S+\.\S+/.test(dataCheck.email)) {
            formIsValid = false;
            errors.email = 'Email không hợp lệ';
          }
        }

        // Kiểm tra trường bank_name
        if (!dataCheck.bank_name) {
          formIsValid = false;
          errors.bank_name = 'Vui lòng nhập Ngân Hàng';
        }

        // Kiểm tra trường bank_number
        if (!dataCheck.bank_number) {
          formIsValid = false;
          errors.bank_number = 'Vui lòng nhập Số Tài Khoản';
        }
      }
      switch (typeModal) {
        case "FULL_NAME": // Kiểm tra trường Name update
        if (!dataUpdate.name) {
          formIsValid = false;
          errors.nameUpdate = 'Vui lòng nhập Họ và Tên mới';
        } else {
          contentUpdate = dataUpdate.name;
        }
        break;
        case "PHONE_NUMBER":// Kiểm tra trường phone_number
          if (!dataUpdate.phone_number) {
            formIsValid = false;
            errors.phoneNumberUpdate = 'Vui lòng nhập Số Điện Thoại mới';
          } else if (!/^\d{10}$/.test(dataUpdate.phone_number)) {
            formIsValid = false;
            errors.phoneNumberUpdate = 'Số Điện Thoại mới không hợp lệ';
          } else {
            contentUpdate = dataUpdate.phone_number;
          }
          break;
        case "MAIL":// Kiểm tra trường email
          if (!dataUpdate.email) {
            formIsValid = false;
            errors.emailUpdate = 'Vui lòng nhập Email mới';
          } else if (!/\S+@\S+\.\S+/.test(dataUpdate.email)) {
            formIsValid = false;
            errors.emailUpdate = 'Email mới không hợp lệ';
          } else {
            contentUpdate = dataUpdate.email;
          }
          break;
        case "BANK":// Kiểm tra value bank
          if (!dataUpdate.bank_name) {
            formIsValid = false;
            errors.bankNameUpdate = 'Vui lòng nhập Ngân Hàng mới';
          }
          if (!dataUpdate.bank_number) {
            formIsValid = false;
            errors.bankNumberUpdate = 'Vui lòng nhập Số Tài Khoản mới';
          } else {
            contentUpdate = (dataUpdate.bank_number + " - " + dataUpdate.bank_name + " - " + dataUpdate.province)
          }
          if (!dataUpdate.province) {
            formIsValid = false;
            errors.province = 'Vui lòng nhập chi nhánh Ngân Hàng mới';
          }
          break;
        case "BIRTHDAY":
          if (!dataUpdate.birth_day) {
            formIsValid = false;
            errors.birthDayUpdate = 'Vui lòng chọn ngày tháng năm sinh';
          }
          contentUpdate = dataUpdate.birth_day;
          break;
        case "PASS_LOGIN":
          contentUpdate = "Lấy mật khẩu đăng nhập";
          break;
        case "PASS_WITHDRAW":
          contentUpdate = "Lấy mật khẩu rút tiền";
          break;
        default: break
      }
      console.log(errors)
      setErrors(errors);
      return formIsValid;
    };
    
    const updateUser = async (type) => {
      if (validateForm()) {
        if (type === "MAIL") {
          user.send_type = 'email';
          setIsSendMail(true);
        } else if (type === "PHONE_NUMBER") {
          user.send_type = 'phone_number';
          setIsSendMail(false);
        } else if (type === "AUTO_CONFIRM") {
          user.send_type = 'auto_confirm';
          setIsSendMail(false);
        }
        let body = {
          ...user,
          data_check: {
            ...dataCheck,
          },
          data_update: {
            update_type: user.update_type,
            content: contentUpdate,
          }
        };
        let checkDataOld = await apiCheckDataAccount(body);
        if (checkDataOld) {
          let confirmUpdate = checkDataOld.result;
          let value_auto_check = confirmUpdate ? "check_success" : "check_fail";
          updateUserField("auto_check", value_auto_check);
          body.auto_check = value_auto_check;
          //nếu thông tin đúng hết hoặc đã nhập lại từ 5 lần và có số điện thoại hoặc email đúng thì tự động confirm gửi yêu cầu
          if ((type === "AUTO_CONFIRM") || confirmUpdate || (timesCheckData >= 100 && checkDataOld.allowSubmit >0)) {
            confirmUpdateUser(body, type);
          } else {
            Swal.fire({
              icon: (checkDataOld.countMatch/checkDataOld.count <0.5) ? "error" : "warning",
              title: "Chú ý",
              text: (checkDataOld.allowSubmit == 0) ? "Sai số điện thoại và email liên kết" : "Thông tin cũ bạn nhập đúng " + Math.round(checkDataOld.countMatch/checkDataOld.count*100) + "%",
              showCancelButton: true,
              cancelButtonText: 'Quay về chỉnh sửa',
              confirmButtonText: 'Tiếp tục gửi',
              // chỉ khi có ít nhất 1 thông tin (số điện thoại hoặc email) đúng thì mới hiển thị nút confirm gửi yêu cầu
              showConfirmButton: (checkDataOld.allowSubmit > 0),
              reverseButtons: true
            }).then((result) => {
              if (result.isConfirmed) {
                confirmUpdateUser(body, type);
              } else if (result.isDismissed) {
                setTimesCheckData(timesCheckData + 1)
              }
            });
          }
        }
      }
    };
    
    const confirmUpdateUser = async (body, type) => {
      let updateInfo = await apiUpdateAccount(body);
      const newRequestCode = updateInfo?.request_code ? String(updateInfo.request_code) : "";
      if (newRequestCode) {
        const newRequest = {
          ...body,
          request_code: newRequestCode,
          _request_code: newRequestCode,
          status: "no_process",
          verification_status: "not_received",
          createdAt: new Date().toISOString(),
        };
        requestSession.current += 1;
        setUser((currentUser) => ({ ...currentUser, request_code: newRequestCode }));
        setSubmittedRequest(newRequest);
        setRecentRequests((items) => [
          { ...newRequest, request_code: `xxxxxx${newRequestCode.slice(-2)}` },
          ...items,
        ].slice(0, 2));
        setPollingChecks(0);
        setRequestRefreshMessage("");
        openModalConfirm(type);
      }

    };

    const resetValidate = async (type) => {
      validateForm();
      setErrors({});
    };

    const resetDataUpdate = async (type) => {
      setDataUpdate(originalDataUpdate);
    };


    const closeModalConfirm = () => {
      requestSession.current += 1;
      setOpenConfirm(false);
      const overlay = document.getElementsByClassName("popup-overlay")[0];
      if (overlay) overlay.style.visibility = "visible";
    };

    // không còn sử dụng
    // const openModalSuccess = async () => {
      
    //   let body = {
    //     user: user,
    //     userInforCheck: dataCheck,
    //     userInforPending: dataUpdate,
    //   };
    //   let checkConfirmUpdate = await apiConfirmUpdate(body);
    //   setCheckConfirm(checkConfirmUpdate);
    //   setOpen(false);
    //   setOpenConfirm(false);
    //   setOpenResult(true);
    // };

    return (
      <div className="container">
        <motion.div
          // className="app"
          // initial={{ opacity: 0 }}
          // animate={{ opacity: 1 }}
          // transition={{ duration: 5 }}
          // className="app"
          // initial={{ x: "-100vw", opacity: 0 }}
          // animate={{ x: 0, opacity: 1 }}
          // exit={{ x: "100vw", opacity: 0 }}
          // transition={{ type: "spring", stiffness: 100, damping: 20 }}
          className="app"
          initial={{ x: "100vw", opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: "-100vw", opacity: 0 }}
          transition={{ type: "spring", stiffness: 1000, damping: 200, duration: 10 }}
        >
          <Header isPageSearch={false} />

          <div className="content">
            <div className="profile">
              {/* <span className="profile-titlte">THÔNG TIN TÀI KHOẢN</span>
              <InfoUser /> */}
                <div className="request-history">
                  <div className="request-history-heading">
                    <span className="profile-titlte">LỊCH SỬ YÊU CẦU  &nbsp;
                      <span className="request-history-help" onMouseEnter={() => setShowRequestHistoryHelp(true)} onMouseLeave={() => setShowRequestHistoryHelp(false)}>
                        <button type="button" className="request-history-help-icon" aria-label="Thông tin lịch sử yêu cầu" onClick={() => setShowRequestHistoryHelp((value) => !value)}>!</button>
                        {showRequestHistoryHelp && <div className="request-history-help-content">Danh sách chỉ hiển thị tối đa 2 yêu cầu gần nhất trong 48 giờ. Nhập mã yêu cầu 8 số để xem chi tiết kết quả xử lý.</div>}
                      </span>
                    </span>
                    <button type="button" aria-label="Thu gọn hoặc mở rộng lịch sử" aria-expanded={!isRequestHistoryCollapsed} className="request-history-collapse-button" onClick={() => setIsRequestHistoryCollapsed((value) => !value)}>{isRequestHistoryCollapsed ? "+" : "−"}</button>
                  </div>
                  {!isRequestHistoryCollapsed && recentRequests.length > 0 && <div className="recent-requests">
                    {recentRequests.map((request, index) => <div className={`recent-request-item status-${request.status}`} key={`${request._request_code || request.request_code}-${index}`}>
                      <div className="recent-request-main"><strong>{requestTypeText[request.update_type] || request.update_type}</strong><span className="recent-request-code">{maskRequestCode(request.request_code)}</span></div>
                      <div className="recent-request-meta">
                        <span className={`recent-request-status status-${request.status}`}>{requestStatusText[request.status] || request.status}</span>
                        {request.status === "no_process" && ["email", "phone_number"].includes(request.send_type) && <span className={`verification-status verification-${request.verification_status || "not_received"}`}>{getVerificationStatusText(request.verification_status || "not_received", request.send_type)}</span>}
                      </div>
                    </div>)}
                  </div>}
                  <div className="request-history-form">
                    <input type="text" inputMode="numeric" maxLength="8" value={requestCode} onChange={(event) => { setRequestCode(event.target.value.replace(/\D/g, "")); setRequestHistoryError(""); }} onKeyDown={(event) => event.key === "Enter" && checkRequestHistory()} placeholder="Nhập mã yêu cầu 8 số" />
                    <button type="button" disabled={isCheckingHistory} onClick={checkRequestHistory}>{isCheckingHistory ? "Đang kiểm tra..." : "Kiểm tra"}</button>
                  </div>
                  {requestHistoryError && <p className="request-history-error">{requestHistoryError}</p>}
                </div>
              <span className="profile-titlte">THAY ĐỔI MỤC THÔNG TIN MỚI</span>
              <div className="action">
                <button className="action-btn" onClick={() => openModal("FULL_NAME")}>
                  <img src={iconUser} alt="icon-user" />
                  ĐỔI HỌ VÀ TÊN
                </button>
                <button className="action-btn" onClick={() => openModal("PHONE_NUMBER")}>
                  <img src={iconPhone} alt="icon-phone" />
                  &nbsp; THAY ĐỔI SĐT
                </button>
              </div>
              <div className="action">
                <button className="action-btn" onClick={() => openModal("MAIL")}>
                  <img src={iconMail} alt="icon-mail" />
                  &nbsp; THAY ĐỔI GMAIL
                </button>
                <button className="action-btn" onClick={() => openModal("BANK")}>
                  <img src={iconBank} alt="icon-bank" />
                  &nbsp; THAY ĐỔI STK <br/> NGÂN HÀNG
                </button>
              </div>
              <div className="action">
                <button className="action-btn" onClick={() => openModal("PASS_LOGIN")}>
                  <img src={iconPassLogin} alt="icon-pass-login" />
                  &nbsp; ĐỔI MẬT KHẨU <br/> ĐĂNG NHẬP
                </button>
                <button className="action-btn" onClick={() => openModal("PASS_WITHDRAW")}>
                  <img src={iconPassWithdraw} alt="icon-pass-withdraw" />
                  &nbsp; ĐỔI MẬT KHẨU <br/> RÚT TIỀN
                </button>
              </div>
              {data.change_birthday &&
              <div className="action-only">
                <button className="action-btn" onClick={() => openModal("BIRTHDAY")}>
                  <img src={iconBirthday} alt="icon-birthday" />
                  &nbsp; CẬP NHẬT NGÀY SINH
                </button>
              </div>
              }
            </div>
            <Popup open={open} onClose={() => {setOpen(false); document.body.style.overflow = 'auto';}} position={"center"} closeOnDocumentClick={false} nested>
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} id="modal-info" className="modal-info">
                <div className="modal-close">
                  <button className="icon-close" onClick={() => {setOpen(false); resetValidate(); resetDataUpdate()}} onAnimationEnd={() => setOpen(false)}>
                    <img src={iconClose} alt="icon-close" />
                  </button>
                </div>
                <div className="info-current">
                  <Collapsible open={true} trigger={["THÔNG TIN CÁ NHÂN", <img src={iconArrow} key="icon-arrow" alt="icon-arrow" />]}>
                    <InfoUser />
                  </Collapsible>
                </div>
                {typeModal != "BIRTHDAY" &&
                <div className="confirm-info-old">
                  <span className="modal-titlte">VUI LÒNG NHẬP LẠI THÔNG TIN ĐÃ LIÊN KẾT</span>
                  <div className="input-info">
                    <input type="text" name="name" value={dataCheck.name} onChange={inputDataCheck} placeholder="Họ Và Tên" />
                    {errors.name && <p className="error">{errors.name}</p>}
                    <input type="text" name="phone_number" value={dataCheck.phone_number} onChange={inputDataCheck} placeholder="Số Điện Thoại" />
                    {errors.phone_number && <p className="error">{errors.phone_number}</p>}
                    <input type="text" name="email" value={dataCheck.email} onChange={inputDataCheck} placeholder="Gmail" />
                    {errors.email && <p className="error">{errors.email}</p>}
                    <input type="text" name="bank_name" value={dataCheck.bank_name} onChange={inputDataCheck} placeholder="Ngân Hàng" />
                    {errors.bank_name && <p className="error">{errors.bank_name}</p>}
                    <input type="text" name="bank_number" value={dataCheck.bank_number} onChange={inputDataCheck} placeholder="Số Tài Khoản" />
                    {errors.bank_number && <p className="error">{errors.bank_number}</p>}
                  </div>
                </div>
                }
                <div className="confirm-info-new">
                  <span className="modal-titlte">{
                    typeModal === "PASS_LOGIN"
                      ? "LẤY MẬT KHẨU ĐĂNG NHẬP"
                      : typeModal === "PASS_WITHDRAW"
                        ? "LẤY MẬT KHẨU RÚT TIỀN"
                        : "THAY ĐỔI THÔNG TIN MỚI"
                  }</span>
                  {
                    {
                      "FULL_NAME": 
                      <div className="input-info">
                        <input type="text" name="name" onChange={inputDataUpdate} placeholder="Họ Tên Mới" />
                        {errors.nameUpdate && <p className="error">{errors.nameUpdate}</p>}
                      </div>,
                      "PHONE_NUMBER": 
                      <div className="input-info">
                        <input type="text" name="phone_number" onChange={inputDataUpdate}  placeholder="Số Điện Thoại Mới" />
                        {errors.phoneNumberUpdate && <p className="error">{errors.phoneNumberUpdate}</p>}
                      </div>,
                      "MAIL": 
                      <div className="input-info">
                        <input type="text" name="email" onChange={inputDataUpdate} placeholder="Email Mới" />
                        {errors.emailUpdate && <p className="error">{errors.emailUpdate}</p>}
                        </div>,
                      "BANK": 
                      <div className="input-info">
                        <input type="text" name="bank_name" onChange={inputDataUpdate} placeholder="Tên Ngân Hàng Mới" />
                        {errors.bankNameUpdate && <p className="error">{errors.bankNameUpdate}</p>}
                        <input type="text" name="bank_number" onChange={inputDataUpdate} placeholder="Số Tài Khoản Ngân Hàng Mới" />
                        {errors.bankNumberUpdate && <p className="error">{errors.bankNumberUpdate}</p>}
                        <input type="text" name="province" onChange={inputDataUpdate} placeholder="Chi Nhánh Ngân Hàng Mới" />
                        {errors.province && <p className="error">{errors.province}</p>}
                      </div>,
                      "BIRTHDAY": 
                      <div className="input-info">
                        <input type="date" name="birth_day" onChange={inputDataUpdate} placeholder="ngày tháng năm sinh" defaultValue="2000-12-01"/>
                        {errors.birthDayUpdate && <p className="error">{errors.birthDayUpdate}</p>}
                      </div>,
                    }[typeModal]
                  }
                </div>
                <div className="mode-verify">
                  <span className="modal-titlte">{typeModal === "BIRTHDAY" ? "XÁC NHẬN THÊM NGÀY SINH" : "VUI LÒNG LỰA CHỌN HÌNH THỨC GỬI XÁC THỰC"}</span>
                  <div className="action action-verify">
                    {(typeModal === "BIRTHDAY") ?
                      <button onClick={() => updateUser("AUTO_CONFIRM")} className="action-verify-btn">
                        &nbsp; XÁC NHẬN NGÀY SINH
                      </button>
                      :
                      <>
                      { data.email &&
                      <button onClick={() => updateUser("MAIL")} className="action-verify-btn">
                        <img src={iconSendMail} alt="icon-bank" />
                        &nbsp; XÁC THỰC EMAIL
                      </button>
                      }
                      { data.phone_number &&
                      <button onClick={() => updateUser("PHONE_NUMBER")} className="action-verify-btn">
                        <img src={iconSendPhone} alt="icon-bank" />
                        &nbsp; XÁC THỰC SĐT
                      </button>
                      }
                      </>
                    }
                  </div>
                </div>
              </motion.div>
            </Popup>
            <Popup
              open={openRequestHistoryResult}
              onClose={() => setOpenRequestHistoryResult(false)}
              position="center"
              closeOnDocumentClick
              overlayStyle={{ display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0, 0, 0, 0.35)" }}
              contentStyle={{ position: "relative", inset: "auto", width: "auto", padding: 0, border: "none", background: "transparent" }}
            >
              <div className="request-history-modal">
                <button className="request-history-modal-close" onClick={() => setOpenRequestHistoryResult(false)}><img src={iconClose} alt="Đóng" /></button>
                {requestHistory && <div className={`request-history-result status-${requestHistory.status}`}>
                  <h3>KẾT QUẢ YÊU CẦU</h3>
                  <p><strong>Loại yêu cầu:</strong> {requestTypeText[requestHistory.update_type] || requestHistory.update_type}</p>
                  {requestHistory.data_update?.content && <p><strong>Nội dung yêu cầu:</strong> {requestHistory.data_update.content}</p>}
                  <p><strong>Trạng thái:</strong> {requestStatusText[requestHistory.status] || requestHistory.status}</p>
                  {["email", "phone_number"].includes(requestHistory.send_type) && <p className={`verification-status verification-${requestHistory.verification_status || "not_received"}`}>{getVerificationStatusText(requestHistory.verification_status || "not_received", requestHistory.send_type)}</p>}
                  {(requestHistory.note || requestHistory.result) && <div className="request-result-note"><strong>Ghi chú/Kết quả:</strong><HtmlNote html={requestHistory.note || requestHistory.result} /></div>}
                  {requestHistory.createdAt && <p><strong>Ngày gửi:</strong> {new Date(requestHistory.createdAt).toLocaleString("vi-VN")}</p>}
                </div>}
              </div>
            </Popup>
            <Popup open={openConfirm} closeOnDocumentClick={false} onClose={closeModalConfirm} position={"center"} nested>
              <motion.div
                initial={{ opacity: 0, y: 75 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                id="modal-confirm"
                className="modal-confirm request-confirm-modal"
              >
                <div className="modal-close">
                  <a className="icon-close" onClick={closeModalConfirm}>
                    <img src={iconClose} alt="icon-close" />
                  </a>
                </div>
                {user.send_type === 'auto_confirm' ? (
                  <div className="modal-confirm-content">
                    <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                    <DataConfirm user={user} webSetting={webSetting} />
                    <span>Yêu cầu của quý khách đã được ghi nhận. Vui lòng đợi xét duyệt từ 5-10 phút.</span>
                    <div className="btn-wrapper-home">
                      <div className="btn-send btn-home">
                          <a href={ webSetting.link_home }
                              target="_blank"
                              rel="noopener noreferrer">VỀ TRANG CHỦ
                          </a>
                      </div>
                    </div>
                    <div className="notification">
                      <p style={{ color: "#F7B922", padding: "3px 0px",margin: "0px"}}>Lưu ý:</p>
                      <p>- Quý khách vui lòng kiểm tra kết quả xử lý của hệ thống tại Hòm Thư.</p>
                      <p>- Liên hệ <a href={ webSetting.link_cskh }
                        target="_blank"
                        rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
                  </div>
                  </div>
                ): (
                <div className="modal-confirm-content">
                  <img className="icon-warning" src={iconWarning} />
                  {isSendMail ? (
                    <p>
                      Vui lòng sử dụng gmail đã liên kết <span style={{ color: "green" }}>{data.email}</span>, gửi tin nhắn tới email 798BET{" "}
                      <span style={{ color: "red" }}>{ webSetting.email }</span>, với nội dung:
                    </p>
                  ) : (
                    <p>
                      Vui lòng sử dụng số điện thoại đã liên kết <span style={{ color: "green" }}>{data.phone_number}</span>, gửi tin nhắn tới số điện thoại 798BET{" "}
                      <span style={{ color: "red" }}>{ webSetting.phone_number }</span>, với nội dung:
                    </p>
                  )}
                  <DataConfirm user={user}
                  dataCheck = {dataCheck}
                  dataUpdate = {dataUpdate}
                  webSetting = {webSetting}/>
                  {submittedRequest && <div className={`request-processing-status status-${submittedRequest.status} verification-${["email", "phone_number"].includes(submittedRequest.send_type) ? submittedRequest.verification_status || "not_received" : "success"}`}>
                    {submittedRequest.status === "no_process" && <div className={`request-live-update-notice ${pollingChecks >= 15 ? "request-live-update-stopped" : ""}`} role="status" aria-live="polite">
                      {pollingChecks < 15 ? <span className="request-loading-icon" aria-hidden="true" /> : <span className="request-update-paused-icon" aria-hidden="true">✓</span>}
                      <div>
                        <strong>{pollingChecks < 15 ? "Hệ thống đang tự động cập nhật trạng thái" : "Yêu cầu chưa được xử lý"}</strong>
                        <small>{pollingChecks < 15 ? "Vui lòng giữ màn hình này mở và chờ kết quả xử lý, hoặc copy lại mã yêu cầu để kiểm tra lại." : "Bạn có thể bấm Kiểm tra lại để lấy trạng thái mới nhất."}</small>
                      </div>
                      {requestRefreshMessage && <p className="request-refresh-message" role="status">{requestRefreshMessage}</p>}
                  </div>}
                    <strong className="request-processing-title">
                      {submittedRequest.status === "approved"
                        ? "Yêu cầu đã được xử lý thành công"
                        : submittedRequest.status === "removed"
                          ? "Yêu cầu đã bị từ chối"
                          : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success"
                            ? "Yêu cầu đang chờ xác thực"
                            : pollingChecks < 15 ? "Yêu cầu đang được xử lý" : "Yêu cầu đang được xử lý lâu hơn dự kiến"}
                    </strong>
                    {/* <p className="submitted-request-code">Mã yêu cầu: <strong>{submittedRequest.request_code}</strong></p> */}
                    {(submittedRequest.note || submittedRequest.result) && <div className="request-result-note"><strong>Kết quả xử lý:</strong><HtmlNote html={submittedRequest.note || submittedRequest.result} /></div>}
                    <div className="request-progress">
                      <div className="request-progress-step step-complete"><span>1</span><small>Đã gửi yêu cầu</small></div>
                      <div className={`request-progress-step ${!["email", "phone_number"].includes(submittedRequest.send_type) || submittedRequest.verification_status === "success" ? "step-complete" : submittedRequest.verification_status === "invalid" ? "step-error" : "step-current"}`}><span>2</span><small>{["email", "phone_number"].includes(submittedRequest.send_type) ? "Xác thực" : "Đã tiếp nhận"}</small></div>
                      <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : ["email", "phone_number"].includes(submittedRequest.send_type) && submittedRequest.verification_status !== "success" ? "step-pending" : "step-current"}`}><span>3</span><small>Đang xử lý</small></div>
                      <div className={`request-progress-step ${submittedRequest.status === "approved" ? "step-complete" : submittedRequest.status === "removed" ? "step-error" : "step-pending"}`}><span>4</span><small>Hoàn tất</small></div>
                    </div>
                    {submittedRequest.status === "no_process" && <div className="request-processing-message">
                      {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "email" && <p>Chưa nhận xác thực. Vui lòng gửi từ email đã liên kết.</p>}
                      {submittedRequest.verification_status === "not_received" && submittedRequest.send_type === "phone_number" && <p>Chưa nhận xác thực. Vui lòng gửi từ số điện thoại đã liên kết.</p>}
                      {submittedRequest.verification_status === "invalid" && <p>Xác thực không hợp lệ. Vui lòng kiểm tra thông tin và gửi lại.</p>}
                      {pollingChecks >= 15 && <><p>Yêu cầu đang xử lý lâu hơn dự kiến.</p><div className="request-processing-actions"><button type="button" onClick={refreshSubmittedRequest} disabled={isRefreshingRequest}>{isRefreshingRequest ? "Đang kiểm tra..." : "Kiểm tra lại"}</button><button type="button" onClick={copySubmittedRequestCode}>Sao chép mã</button></div></>}
                    </div>}
                  </div>}
                  {/* <div style={{ marginTop: "15px" }}>
                    <p className="text-confirm-bottom">Vui lòng nhấn Xác nhận sau khi đã gửi thành công</p>
                    <button onClick={openModalSuccess} className="btn-send-mail">
                      XÁC NHẬN ĐÃ GỬI
                    </button>
                  </div> tạm thời không xử lý xác nhận đã gửi*/}
                  <div className="notification">
                    <p>- Liên hệ <a href={ webSetting.link_cskh || "https://iro6rszf.789bhotro.com/" }
                      target="_blank"
                      rel="noopener noreferrer">CSKH</a> nếu cần hỗ trợ thêm.</p>
                  </div>
                </div>
                )}
              </motion.div>
            </Popup>
            <Popup open={openResult} onClose={() => setOpenResult(false)} position={"center"}>
              <motion.div initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="modal-success">
                <div className="modal-close">
                  <a className="icon-close" onClick={() => setOpenResult(false)}>
                    <img src={iconClose} alt="icon-close" />
                  </a>
                </div>
                {checkConfirm ? (
                  <div className="modal-result-content">
                    <img style={{ marginBottom: "20px" }} src={iconSuccess} alt="icon-success" />
                    <span>Chúng tôi đã nhận được yêu cầu của Quý khách, vui lòng chờ 2-5 phút và nhận kết quả phản hồi tại Hòm thư nội bộ</span>
                  </div>
                  ) : (
                  <div className="modal-result-content">
                    <img style={{ marginBottom: "20px" }} src={iconWarning} alt="icon-success" />
                    <span>Yêu cầu của bạn chưa được ghi nhận, vui lòng thử lại hoặc liên hệ chăm sóc khách hàng</span>
                  </div>
                )}
              </motion.div>
            </Popup>
          </div>
        </motion.div>
      </div>
    );
  }
}

export default Profile;
